module.exports = __webpack_public_path__ + "static/media/profile.0788d310.png";